export class HttpError extends Error {
  constructor(options) {
    super("".concat(options.method, " ").concat(options.url, " (").concat(options.status, "): ").concat(options.text, "."));
    this.name = 'HttpError';
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}